<template>
  <div class="u-text-align-center u-padding-top u-padding-bottom">
    <img
      class="u-no-found-image"
      :src="noFoundImage"
      :alt="$t('noFoundData')"
    />

    <div>
      <small class="u-font-size-xsmall"
        ><i>{{ $t("noFoundData") }}</i></small
      >
    </div>
  </div>
</template>

<script>
const noFoundImage = require("@/assets/images/nofound.png");

export default {
  data() {
    return {
      noFoundImage,
    };
  },
};
</script>

<style></style>
